/**
  * 登录模块接口列表
  */

 import base from './base'; // 导入接口域名列表
 import axios from '@/axios'; // 导入axios实例
 import qs from 'qs'; // 根据需求是否导入qs模块
 
 const login = {
     // 登录
     login (params) {
         return axios.post(`${base.default}/user/login`,qs.stringify(params));
     },
       //登录
       authLogin(params){
        return axios.get(`${base.default}/login/token`, {params:params});
    },
    //登出
    authLogout(params){
        return axios.get(`/localAuth/oauth/logout`, {params:params});
    },
     //刷新token
     refreshToken(params){
        return axios.post(`${base.default}/login/refreshToken`, qs.stringify(params));
    },
 }
 
 export default login;
